import { Component } from '@theme/component';

/** Delegates both recommendation rows (including lazy recent cards) to the existing bag writer. */
class AtelierCardAdds extends Component {
  #listeners; #busy = false; #uncertain = false; #timers = new Map(); #labels = new WeakMap();
  connectedCallback() {
    super.connectedCallback(); this.#listeners?.abort(); this.#listeners = new AbortController();
    this.addEventListener('submit', this.#submit, { signal: this.#listeners.signal });
  }
  #buttons() { return [...this.querySelectorAll('[data-atelier-card-add]')]; }
  #sync() {
    this.setAttribute('aria-busy', String(this.#busy));
    for (const button of this.#buttons()) button.disabled = this.#busy || this.#uncertain || button.form.dataset.ready !== 'true';
  }
  #submit = async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-atelier-card-form]')) return;
    event.preventDefault(); event.stopPropagation();
    if (this.#busy || this.#uncertain) return;
    const button = form.querySelector('[data-atelier-card-add]'), status = form.querySelector('[data-atelier-card-status]');
    const values = new FormData(form), id = String(values.get('id') || '');
    // Only a validated colour card may submit quantity 1. Never infer it from a displayed price.
    if (form.dataset.ready !== 'true' || !/^[1-9]\d*$/.test(id) || id !== form.dataset.variantId || values.get('quantity') !== '1') {
      status.textContent = this.dataset.invalid; return;
    }
    if (this.dataset.cartType !== 'drawer') { HTMLFormElement.prototype.submit.call(form); return; }
    const bag = document.getElementById('cart-drawer');
    if (typeof bag?.addItems !== 'function') { status.textContent = this.dataset.failed; return; }
    if (!this.#labels.has(button)) this.#labels.set(button, { text: button.textContent, name: button.getAttribute('aria-label') });
    const { text: original, name: originalName } = this.#labels.get(button);
    clearTimeout(this.#timers.get(button)); this.#timers.delete(button);
    this.#busy = true; this.#sync(); button.textContent = this.dataset.adding; button.setAttribute('aria-label', `${this.dataset.adding} — ${originalName}`); status.textContent = this.dataset.adding;
    form.querySelector('[data-atelier-card-review]').hidden = true;
    try {
      await bag.addItems([{ id, quantity: 1 }], { page_type: 'product', source_surface: 'storefront', component_id: 'atelier-colour-card' }, { openImmediately: true });
      if (!this.isConnected) return;
      button.textContent = `✓ ${this.dataset.added}`; button.setAttribute('aria-label', `${this.dataset.added} — ${originalName}`);
      status.textContent = this.dataset.added;
      const timer = setTimeout(() => {
        this.#timers.delete(button);
        if (button.isConnected) { button.textContent = original; button.setAttribute('aria-label', originalName); status.textContent = ''; }
      }, 1500);
      this.#timers.set(button, timer);
    } catch (error) {
      this.#uncertain = error.cartResult !== 'rejected';
      if (!this.isConnected) return;
      button.textContent = original; button.setAttribute('aria-label', originalName);
      status.textContent = this.#uncertain ? this.dataset.uncertain : error.message || this.dataset.failed;
      form.querySelector('[data-atelier-card-review]').hidden = !this.#uncertain;
    } finally {
      this.#busy = false; if (this.isConnected) this.#sync();
    }
  };
  disconnectedCallback() {
    super.disconnectedCallback(); this.#listeners?.abort();
    for (const timer of this.#timers.values()) clearTimeout(timer); this.#timers.clear();
    // Keep an in-flight cart write alive: cancellation would leave its result unknown.
  }
}
if (!customElements.get('fivepoint-atelier-card-adds')) customElements.define('fivepoint-atelier-card-adds', AtelierCardAdds);
